import React, { useMemo } from 'react';
import Plot from 'react-plotly.js';

/**
 * Component for visualizing embeddings in a 2D scatter plot
 */
const EmbeddingPlot = ({
  data,
  onPointSingleClick,
  selectedPoint
}) => {
  // Transform the data into format required by Plotly
  const plotData = useMemo(() => {
    if (!data || data.length === 0) return [];

    // Separate selected point if any
    const regularPoints = selectedPoint 
      ? data.filter(d => d.id !== selectedPoint.id) 
      : data;
    
    const selectedPointData = selectedPoint ? [selectedPoint] : [];

    return [
      // Regular points
      {
        type: 'scatter',
        mode: 'markers',
        x: regularPoints.map(d => d.coordinates[0]),
        y: regularPoints.map(d => d.coordinates[1]),
        text: regularPoints.map(d => {
          const title = d.data && d.data.use_case && d.data.use_case.title;
          return title ? `${title}` : `ID: ${d.id}`;
        }),
        marker: {
          size: 10,
          color: '#10A37F',
          opacity: 0.8,
          line: {
            color: '#343541',
            width: 1
          }
        },
        hoverinfo: 'text',
        customdata: regularPoints.map(d => d.id),
        name: 'Embeddings'
      },
      // Selected point (highlighted)
      ...(selectedPoint ? [{
        type: 'scatter',
        mode: 'markers',
        x: [selectedPoint.coordinates[0]],
        y: [selectedPoint.coordinates[1]],
        text: [(() => {
          const title = selectedPoint.data && selectedPoint.data.use_case && selectedPoint.data.use_case.title;
          return title ? `${title} (Selected)` : `ID: ${selectedPoint.id} (Selected)`;
        })()],
        marker: {
          size: 15,
          color: '#F9FAFB',
          line: {
            color: '#10A37F',
            width: 2
          }
        },
        hoverinfo: 'text',
        customdata: [selectedPoint.id],
        name: 'Selected'
      }] : [])
    ];
  }, [data, selectedPoint]);

  // Click event handler
  const handleClick = (event) => {
    // Only handle events with points
    if (event.points && event.points.length > 0) {
      const point = event.points[0];
      const id = point.customdata;
      
      // Find the full data point
      const clickedPoint = data.find(d => d.id === id);
      
      if (clickedPoint) {
        onPointSingleClick(clickedPoint);
      }
    }
  };

  // Layout configuration for the plot
  const layout = {
    title: 'Embedding Visualization',
    autosize: true,
    hovermode: 'closest',
    margin: { l: 50, r: 50, b: 50, t: 50, pad: 4 },
    xaxis: {
      title: 'Dimension 1',
      zeroline: false,
      gridcolor: '#444654',
      color: '#ACACBE'
    },
    yaxis: {
      title: 'Dimension 2',
      zeroline: false,
      gridcolor: '#444654',
      color: '#ACACBE'
    },
    showlegend: false,
    paper_bgcolor: '#343541',
    plot_bgcolor: '#343541',
    font: {
      color: '#ECECF1'
    }
  };

  const config = {
    responsive: true
  };

  return (
    <div>
      <Plot
        data={plotData}
        layout={layout}
        config={config}
        style={{ width: '100%', height: '500px' }}
        onClick={handleClick}
      />
    </div>
  );
};

export default EmbeddingPlot; 